<div class="negocio-item">
    <div class="negocio-item-foto">
        <figure *ngIf="data.foto != null">
            <img [src]="data.foto" alt="data.nome" width="100%" />
        </figure>
        <figure *ngIf="data.foto == null">
            <img src="/images/foto/foto.svg" alt="data.nome" width="100%" />
        </figure>
    </div>
    <div class="negocio-item-content">  
        <div class="categoria-tarja">
            <div class="icon">
                <img [src]="data.icone" alt="Ícone" width="25px" />
            </div>
            <span>{{data.categoria}}</span>
        </div>
        <h3>{{data.empresa_nome}}</h3>
        <div class="info">
            <div class="item">
                <strong>Proprietário (a): </strong>
                <span>{{data.nome}}</span>
            </div>
            <div class="item" *ngIf="data.link_site != '' && data.link_site != null">
                <strong>Nosso site: </strong>
                <a [href]="data.link_site" target="_blank">{{data.link_site}}</a>
            </div>
        </div>
        <div class="redes-sociais">
            <div class="item" *ngIf="data.link_facebook != null && data.link_facebook != ''">
                <a [href]="data.link_facebook" title="Facebook" target="_blank">
                    <img src="/images/icons/facebook-01.svg" alt="Facebook" width="30px" />
                </a>
            </div>
            <div class="item" *ngIf="data.link_instagram != '' && data.link_instagram != null">
                <a [href]="data.link_instagram" title="Instagram" target="_blank">
                    <img src="/images/icons/instagram-01.svg" alt="Instagram" width="30px" />
                </a>
            </div>
            <div class="item">
                <a href="#" title="Whatsapp" (click)="openWhats()">
                    <img src="/images/icons/whatsapp-02.svg" alt="WhatsApp" width="30px" />
                </a>
            </div>
        </div>
        <div class="content-button">
            <button type="button" class="btn btn-more" (click)="open()">
                <span>Saiba Mais</span>
            </button>
        </div>
    </div>
</div>
